import { useState } from 'react';
import { ChevronDownIcon } from '@heroicons/react/24/outline';

const pluralize = (count) => `${count} outstanding obligation${count === 1 ? '' : 's'}`;

const ObligationStack = ({ records = [], renderRecord, learnerName }) => {
  const [expanded, setExpanded] = useState(false);

  if (records.length === 0) return null;
  if (records.length === 1) return renderRecord(records[0], { index: 0, fullWidth: true });

  return (
    <section
      className="w-full min-w-0"
      aria-label={`${learnerName || records[0]?.studentName || 'Learner'}: ${pluralize(records.length)}`}
    >
      <button
        type="button"
        className="mb-2 flex w-full items-center justify-between rounded-lg px-2 py-1 text-left text-sm font-medium hover:bg-base-200"
        onClick={() => setExpanded(value => !value)}
        aria-expanded={expanded}
      >
        <span>{pluralize(records.length)}</span>
        <span className="flex items-center gap-1 text-xs text-base-content/60">
          {expanded ? 'Collapse' : 'Show each obligation'}
          <ChevronDownIcon className={`h-4 w-4 transition-transform ${expanded ? 'rotate-180' : ''}`} />
        </span>
      </button>

      <div className={expanded ? 'space-y-3' : 'stack stack-start w-full'}>
        {records.map((record, index) => (
          <div
            key={record.id}
            className="w-full min-w-0"
            aria-hidden={!expanded && index > 0 ? 'true' : undefined}
          >
            {renderRecord(record, { index, fullWidth: true })}
          </div>
        ))}
      </div>
    </section>
  );
};

export default ObligationStack;
